const o = "/rest/user/info", c = "/session-customer-identifier/signals/pi", i = "REI_WEB_SSCID", n = "sscid-pi-status", r = () => {
  const t = localStorage.getItem("sscid");
  if (t)
    return t;
  const e = crypto.randomUUID();
  return localStorage.setItem("sscid", e), e;
}, a = () => localStorage.getItem(n) === "201", u = (t) => localStorage.setItem(n, t), l = (t) => ["phone1", "addressLine1", "city", "countryCode", "stateCode", "zipCode"].some((e) => !(t != null && t[e])), d = async () => {
  try {
    const t = await fetch(o, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    });
    return t.ok ? await t.json() : null;
  } catch {
    return null;
  }
}, f = async () => {
  try {
    const t = await d();
    if (t.guest) return null;
    const {
      billingAddress: e
    } = t;
    return l(e) ? null : {
      ciamid: t.universalId,
      firstName: e.firstName,
      lastName: e.lastName,
      email: e.email1,
      phone: e.phone1,
      address: {
        address1: e.addressLine1,
        address2: e.addressLine2 || "",
        city: e.city,
        state: e.stateCode,
        zipCode: e.zipCode,
        countryCode: e.countryCode
      }
    };
  } catch {
    return null;
  }
}, p = async () => {
  const t = await f(), e = r();
  return !e || !t ? null : {
    sscid: e,
    appnamespace: i,
    customerDetails: t
  };
}, y = async (t) => {
  if (!navigator.globalPrivacyControl || a()) return !1;
  const e = {
    ...t
  };
  Object.hasOwn(e, "sscid") || (e.sscid = r());
  try {
    const s = await fetch(c, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(e)
    });
    return u(s.status), s.status === 201;
  } catch (s) {
    return console.error("Error sending PI user value:", s), null;
  }
}, I = async () => {
  if (a()) return !1;
  const t = await p();
  return t ? (y(t).catch(() => null), !0) : !1;
};
export {
  r as getSSCID,
  y as sendPiUserValue,
  I as sscidListener
};
